export type ThemePreference = 'system' | 'light' | 'dark'

export const THEME_STORAGE_KEY = 'multiscreen-theme'

export const isThemePreference = (value: unknown): value is ThemePreference => {
    return value === 'system' || value === 'light' || value === 'dark'
}

// Runs before the first paint (see _document.tsx) so a saved dark theme never flashes light.
export const themeInitScript = `(function(){try{var s=localStorage.getItem('${THEME_STORAGE_KEY}');var m=window.matchMedia('(prefers-color-scheme: dark)').matches;var d=s==='dark'||((!s||s==='system')&&m);var r=document.documentElement;if(d){r.classList.add('dark')}r.style.colorScheme=d?'dark':'light'}catch(e){}})()`
